import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueIntercom from 'vue-intercom';
import config from '@/config'
// import LottieAnimation from 'lottie-vuejs' // import lottie-vuejs

// Vue.use(LottieAnimation)

Vue.use(VueIntercom, { appId: config.intercomId });

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import configureFakeBackend from './helpers/fake-backend'


/* old css
import './assets/css/components.css'
import './assets/css/normalize.css'
import './assets/css/supreme-access-v1.css'
*/

// waseem csss
import './assets/index.css'
/*import './assets/main.css'
import './assets/responsive.css'
import './assets/reset.css' */


Vue.use(BootstrapVue)

if (process.env.NODE_ENV == 'development') {
  // console.log('configuring fake backend')
  // configureFakeBackend()
}


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')